import styled from "@emotion/styled";
import { ToggleButton as ToggleButtonRaw } from "components/ToggleButton/ToggleButton";
import { GlobalStore } from "store/global/GlobalStore";
import { useStoreState } from "pullstate";
import { useState } from "react";
import { isObject } from "lodash-es";

type Theme = {
  Desktop: {
    Paragraph: {
      Medium: string;
    };
  };
};

type GlobalStoreState = {
  // Define the structure of your GlobalStore state
  // Example:
  theme: Theme;
  // ... other properties
};

export const DebugPanelGlobalStoreToggle = () => {
  const theme = GlobalStore.useState((s: GlobalStoreState) => s.theme);
  const [showGlobalStoreStates, setShowGlobalStoreStates] = useState<boolean>(false);
  const [expandedKeys, setExpandedKeys] = useState<Array<string>>([]);
  const globalStore = useStoreState(GlobalStore);

  const handleToggleExpand = (key: string) => {
    setExpandedKeys(
      (prev: Array<string>): Array<string> =>
        prev.includes(key) ? prev.filter(k => k !== key) : [...prev, key]
    );
  };

  const handleCopyToClipboard = (value: unknown) => {
    void navigator.clipboard.writeText(JSON.stringify(value, null, 4));
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          alignContent: "center",
          font: theme.Desktop.Paragraph.Medium,
          marginBottom: 6,
        }}
      >
        <span>Global store states:</span>
        <ToggleButton
          toggleButtonText=""
          checked={showGlobalStoreStates}
          handleOnToggle={() => {
            setShowGlobalStoreStates((s: boolean) => !s);
          }}
        />
      </div>
      {showGlobalStoreStates &&
        Object.entries(globalStore).map(([key, value]) => {
          const isObjectValueOrObjectArray =
            (typeof value === "object" && value !== null) || Array.isArray(value);
          const isExpanded = expandedKeys.includes(key);

          const isEmpty =
            isObjectValueOrObjectArray &&
            (Array.isArray(value)
              ? value.length === 0
              : isObject(value) && Object.keys(value).length === 0);
          let content;

          if (isObjectValueOrObjectArray && isExpanded) {
            content = (
              <div>
                {Array.isArray(value) ? (
                  value.map((item, index) => (
                    <div key={index}>
                      <span>{JSON.stringify(item, null, 4)}</span>
                      {index < value.length - 1 && <br />}{" "}
                      {/* Add line break except for the last item */}
                    </div>
                  ))
                ) : (
                  <span>{JSON.stringify(value, null, 4)}</span>
                )}
              </div>
            );
          } else if (!isObjectValueOrObjectArray) {
            content = <span>{String(value)}</span>;
          } else {
            content = null; // or an empty string if you prefer
          }

          return (
            <div key={key} style={{ maxWidth: "200px" }}>
              <span
                onClick={() => (isObjectValueOrObjectArray ? handleCopyToClipboard(value) : "")}
              >
                {key}:
                {isObjectValueOrObjectArray && !isEmpty && (
                  <Caret onClick={() => handleToggleExpand(key)} expanded={isExpanded} />
                )}
              </span>
              {content}
            </div>
          );
        })}
    </div>
  );
};

// Sub-components

export const ToggleButton = styled(ToggleButtonRaw)(() => {
  return { color: "white!important" };
});

type CaretProps = {
  onClick: () => void;
  expanded: boolean;
};

export const Caret: React.FC<CaretProps> = ({ onClick, expanded }) => (
  <span
    onClick={onClick}
    style={{
      cursor: "pointer",
      marginLeft: "4px",
    }}
  >
    {expanded ? "▼" : "▶"}
  </span>
);
